<template>
  <div class="center">
    <div class="footer">
      <div class="bottom">
        <div class="row flex_between">
          <div class="marginTop">
            <div class="bottom_explain">了解赞百</div>
            <div class="bottom_text" @click="$router.push('/know')">公司介绍</div>
            <div class="bottom_text" @click="$router.push('/success')">成功案例</div>
            <div class="bottom_text" @click="$router.push('/contact')">联系我们</div>
          </div>
          <div class="marginTop">
            <div class="bottom_explain">专业服务</div>
            <div class="bottom_text" @click="$router.push('/serve')">客户服务</div>
            <div class="bottom_text" @click="$router.push('/owner')">业主服务</div>
            <div class="bottom_text" @click="$router.push('/add')">附加值服务</div>
          </div>
          <div class="marginTop">
            <div class="bottom_explain">行业动态</div>
            <div class="bottom_text" @click="$router.push('/analysis')">市场热点</div>
            <div class="bottom_text" @click="$router.push('/trend')">行业趋势分析</div>
          </div>
          <div></div>
          <div></div>
        </div>
        <div class="row flex_between footerWidth">
          <div>
            <div class="bottom_title">全国热线</div>
            <div class="bottom_num">021-60476066</div>
          </div>
          <div>
            <div class="bottom_title">招聘</div>
            <div class="bottom_num">aaronyang@goodal-office.com</div>
          </div>
          <div>
            <div class="bottom_title">业务合作</div>
            <div class="bottom_num">www.ZBGRE.com</div>
          </div>
          <div></div>
          <div></div>
          <div></div>
        </div>
        <!-- <div class="line"></div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  data () {
    return {}
  },
  watch: {},
  created () {

  },
  mounted () {
  },
  methods: {}
}
</script>
<style scoped>
.row {
  display: flex;
}

.logo img {
  width: 5rem;
  height: 7.3rem;
}

.top_img img {
  width: 100%;
  height: 540px;
  object-fit: cover;
}

.el-carousel__item h3 {
  color: #475669;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
  text-align: center;
}

.menu img {
  height: 400px;
  width: 100%;
}

.link_width img {
  width: 20px;
  height: 20px;
  position: relative;
  top: 3px;
  left: 6px;
}

.middle img {
  width: 100%;
  height: 700px;
  object-fit: cover;
}

.bank img {
  height: 51px;
  width: 100%;
}

.flex_between {
  justify-content: space-between;
}

.footer {
  position: absolute;
  width: 70%;
  background: #171717;
  height: 400px;
}

.bottom {
  margin: 0 auto;
  width: 1000px;
  color: #fff;
}

.bottom_title {
  font-size: 16px;
  margin-top: 70px;
  margin-bottom: 14px;
}

.bottom_num {
  font-size: 14px;
}

.bottom_explain {
  font-size: 18px;
  margin-bottom: 14px;
}

.marginTop {
  margin-top: 60px;
}

.bottom_text {
  font-size: 16px;
  line-height: 36px;
  cursor: pointer;
}

.footerImg {
  position: relative;
  top: 50px;
}

.footerImg img {
  height: 220px;
}

.footerWidth {
  width: 800px;
}

.line {
  width: 100%;
  height: 4px;
  background: #fff;
  margin-top: 40px;
}
.center {
  display: flex;
  justify-content: center;
  background: #fff;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue